import { Card, CardContent, CardHeader, Typography } from "@mui/material";
import { ArmorList } from "components/roster/armor-list";
import { sortBy } from "lodash";
import React from "react";
import { getTextColor, hexToRgb } from "utils/colors";

export const Armors = React.memo((props) => {
  const { data, faction, nameFilter } = props;
  const { color: factionColor } = faction;
  const textColor = factionColor
    ? getTextColor(hexToRgb(factionColor))
    : "white";
  const armors = data
    .getAllArmors(faction)
    .filter((strategy) =>
      nameFilter
        ? (strategy.name || "").toLowerCase().includes(nameFilter.toLowerCase())
        : true
    );
  const armorsSorted = sortBy(armors, "name");
  return (
    <div>
      <Typography sx={{ my: 2 }} variant="h4" component="div" align="center">
        Armors
      </Typography>
      {!armors.length && <p>{"No armors found..."}</p>}
      {!!armors.length && (
        <div className="two-columns">
          {armorsSorted.map((rule, index) => (
            <div style={{ breakInside: "avoid-column" }} key={index}>
              <Card
                className="no-break"
                sx={{
                  border: `2px solid ${factionColor}`,
                  mb: 2,
                }}
              >
                <CardHeader
                  sx={{
                    backgroundColor: factionColor,
                    color: textColor,
                    py: 1,
                  }}
                  title={
                    <Typography fontWeight="bold" variant="h6" component="div">
                      {rule.name}
                    </Typography>
                  }
                />
                <CardContent>
                  {!!rule.description && (
                    <>
                      <i>{rule.description}</i>
                      <hr />
                    </>
                  )}
                  <ArmorList
                    twoColumns={false}
                    faction={faction}
                    data={data}
                    armors={[rule]}
                    rules={data.getAllArmorRules([rule], faction)}
                  />
                </CardContent>
              </Card>
            </div>
          ))}
        </div>
      )}
    </div>
  );
});
